import { useTranslation } from 'react-i18next';

export function isPersianChartLocale(locale: string) { return /^fa(?:-|$)/i.test(locale); }

/** Isolate both parts so Latin units also stay left of Persian numbers in SVG. */
export function formatChartUnit(value: string, unit: string, locale: string) {
  return isPersianChartLocale(locale)
    ? `\u2067\u2066${value}\u2069 \u2068${unit}\u2069\u2069`
    : `\u2066${value} ${unit}\u2069`;
}

export function ChartUnitValue({ value, unit }: { value: string; unit: string }) {
  const { i18n } = useTranslation();
  return <span dir={isPersianChartLocale(i18n.resolvedLanguage ?? i18n.language) ? 'rtl' : 'ltr'}
    className="chart-unit-value" style={{ display: 'inline-flex', alignItems: 'baseline', gap: '.25em', fontSize: 'inherit', color: 'inherit', unicodeBidi: 'isolate' }}>
    <bdi className="chart-unit-value__number">{value}</bdi><bdi className="chart-unit-value__unit">{unit}</bdi>
  </span>;
}
